// extracted by mini-css-extract-plugin
export default {"container":"Vp-z","brandName":"Wp-z","productName":"Xp-z","productNamePdpEnhancements":"Yp-z","breakLongProductName":"Zp-z"};